import { render, staticRenderFns } from "./index.vue?vue&type=template&id=752739a9&scoped=true&class=top-view&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752739a9",
  null
  
)

export default component.exports